const lang = {
  uk: {
    youNeedToCompleteThePreviousLesson: "🥲 Треба закінчити попередній урок",
    logIn: "Увійдіть",
    toYourAccount: "до облікового запису",
    cleaningMyToys: "🤗 Прибираю іграшки",
  },
  en: {
  },
};

export default lang["uk"];
